export default __webpack_public_path__ + "static/media/explore_pink.62051531.svg";